/**
 * used to transform the list of down banks
 *
 * @param downBankList
 *
 * [ used primarily in ./paymentCreationInfoTransformer.js ]
 */

import { bankListTransformer } from './bankListTransformer';


export const downBankListTransformer = (downBankList: any) => bankListTransformer(downBankList);
